import React from "react";
import ShoppingCart from "../images/ShoppingCart.jpg";

const ShoppingCartImg = () => (
  <div className="shoppingCart-img">
    <img src={ShoppingCart} alt="Shopping Cart" />
  </div>
);

export default ShoppingCartImg;